module.exports = __webpack_public_path__ + "static/media/welcom-frame-img-4.a54fb951.jpg";